module.exports = __webpack_public_path__ + "img/student.8f516506.jpeg";